/* tslint:disable */
/* eslint-disable */
/**
 * goal-wear
 * API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Banner } from '../models';
/**
 * BannersApi - axios parameter creator
 * @export
 */
export const BannersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} [active] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersCreate: async (active?: boolean, startDate?: string, endDate?: string, image?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/publicity/banners/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (active !== undefined) { 
                localVarFormParams.append('active', String(active) as any);
            }
    
            if (startDate !== undefined) { 
                localVarFormParams.append('start_date', startDate as any);
            }
    
            if (endDate !== undefined) { 
                localVarFormParams.append('end_date', endDate as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersDestroy: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publicityBannersDestroy', 'id', id)
            const localVarPath = `/api/publicity/banners/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/publicity/banners/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [active] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersPartialUpdate: async (id: number, active?: boolean, startDate?: string, endDate?: string, image?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publicityBannersPartialUpdate', 'id', id)
            const localVarPath = `/api/publicity/banners/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (active !== undefined) { 
                localVarFormParams.append('active', String(active) as any);
            }
    
            if (startDate !== undefined) { 
                localVarFormParams.append('start_date', startDate as any);
            }
    
            if (endDate !== undefined) { 
                localVarFormParams.append('end_date', endDate as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publicityBannersRetrieve', 'id', id)
            const localVarPath = `/api/publicity/banners/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} image 
         * @param {number} [id2] 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersUpdate: async (id: number, image: string, id2?: number, startDate?: string | null, endDate?: string | null, active?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publicityBannersUpdate', 'id', id)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('publicityBannersUpdate', 'image', image)
            const localVarPath = `/api/publicity/banners/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (id2 !== undefined) { 
                localVarFormParams.append('id', id2 as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
            if (startDate !== undefined) { 
                localVarFormParams.append('start_date', startDate as any);
            }
    
            if (endDate !== undefined) { 
                localVarFormParams.append('end_date', endDate as any);
            }
    
            if (active !== undefined) { 
                localVarFormParams.append('active', String(active) as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BannersApi - functional programming interface
 * @export
 */
export const BannersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BannersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} [active] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicityBannersCreate(active?: boolean, startDate?: string, endDate?: string, image?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Banner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicityBannersCreate(active, startDate, endDate, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BannersApi.publicityBannersCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicityBannersDestroy(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicityBannersDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BannersApi.publicityBannersDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicityBannersList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Banner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicityBannersList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BannersApi.publicityBannersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [active] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicityBannersPartialUpdate(id: number, active?: boolean, startDate?: string, endDate?: string, image?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Banner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicityBannersPartialUpdate(id, active, startDate, endDate, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BannersApi.publicityBannersPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicityBannersRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Banner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicityBannersRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BannersApi.publicityBannersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} image 
         * @param {number} [id2] 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicityBannersUpdate(id: number, image: string, id2?: number, startDate?: string | null, endDate?: string | null, active?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Banner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicityBannersUpdate(id, image, id2, startDate, endDate, active, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BannersApi.publicityBannersUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BannersApi - factory interface
 * @export
 */
export const BannersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BannersApiFp(configuration)
    return {
        /**
         * 
         * @param {BannersApiPublicityBannersCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersCreate(requestParameters: BannersApiPublicityBannersCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Banner> {
            return localVarFp.publicityBannersCreate(requestParameters.active, requestParameters.startDate, requestParameters.endDate, requestParameters.image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BannersApiPublicityBannersDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersDestroy(requestParameters: BannersApiPublicityBannersDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.publicityBannersDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersList(options?: RawAxiosRequestConfig): AxiosPromise<Array<Banner>> {
            return localVarFp.publicityBannersList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BannersApiPublicityBannersPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersPartialUpdate(requestParameters: BannersApiPublicityBannersPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Banner> {
            return localVarFp.publicityBannersPartialUpdate(requestParameters.id, requestParameters.active, requestParameters.startDate, requestParameters.endDate, requestParameters.image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BannersApiPublicityBannersRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersRetrieve(requestParameters: BannersApiPublicityBannersRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Banner> {
            return localVarFp.publicityBannersRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BannersApiPublicityBannersUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicityBannersUpdate(requestParameters: BannersApiPublicityBannersUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Banner> {
            return localVarFp.publicityBannersUpdate(requestParameters.id, requestParameters.image, requestParameters.id2, requestParameters.startDate, requestParameters.endDate, requestParameters.active, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for publicityBannersCreate operation in BannersApi.
 * @export
 * @interface BannersApiPublicityBannersCreateRequest
 */
export interface BannersApiPublicityBannersCreateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof BannersApiPublicityBannersCreate
     */
    readonly active?: boolean

    /**
     * 
     * @type {string}
     * @memberof BannersApiPublicityBannersCreate
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof BannersApiPublicityBannersCreate
     */
    readonly endDate?: string

    /**
     * 
     * @type {File}
     * @memberof BannersApiPublicityBannersCreate
     */
    readonly image?: File
}

/**
 * Request parameters for publicityBannersDestroy operation in BannersApi.
 * @export
 * @interface BannersApiPublicityBannersDestroyRequest
 */
export interface BannersApiPublicityBannersDestroyRequest {
    /**
     * 
     * @type {number}
     * @memberof BannersApiPublicityBannersDestroy
     */
    readonly id: number
}

/**
 * Request parameters for publicityBannersPartialUpdate operation in BannersApi.
 * @export
 * @interface BannersApiPublicityBannersPartialUpdateRequest
 */
export interface BannersApiPublicityBannersPartialUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof BannersApiPublicityBannersPartialUpdate
     */
    readonly id: number

    /**
     * 
     * @type {boolean}
     * @memberof BannersApiPublicityBannersPartialUpdate
     */
    readonly active?: boolean

    /**
     * 
     * @type {string}
     * @memberof BannersApiPublicityBannersPartialUpdate
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof BannersApiPublicityBannersPartialUpdate
     */
    readonly endDate?: string

    /**
     * 
     * @type {File}
     * @memberof BannersApiPublicityBannersPartialUpdate
     */
    readonly image?: File
}

/**
 * Request parameters for publicityBannersRetrieve operation in BannersApi.
 * @export
 * @interface BannersApiPublicityBannersRetrieveRequest
 */
export interface BannersApiPublicityBannersRetrieveRequest {
    /**
     * 
     * @type {number}
     * @memberof BannersApiPublicityBannersRetrieve
     */
    readonly id: number
}

/**
 * Request parameters for publicityBannersUpdate operation in BannersApi.
 * @export
 * @interface BannersApiPublicityBannersUpdateRequest
 */
export interface BannersApiPublicityBannersUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof BannersApiPublicityBannersUpdate
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof BannersApiPublicityBannersUpdate
     */
    readonly image: string

    /**
     * 
     * @type {number}
     * @memberof BannersApiPublicityBannersUpdate
     */
    readonly id2?: number

    /**
     * 
     * @type {string}
     * @memberof BannersApiPublicityBannersUpdate
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof BannersApiPublicityBannersUpdate
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof BannersApiPublicityBannersUpdate
     */
    readonly active?: boolean
}

/**
 * BannersApi - object-oriented interface
 * @export
 * @class BannersApi
 * @extends {BaseAPI}
 */
export class BannersApi extends BaseAPI {
    /**
     * 
     * @param {BannersApiPublicityBannersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApi
     */
    public publicityBannersCreate(requestParameters: BannersApiPublicityBannersCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return BannersApiFp(this.configuration).publicityBannersCreate(requestParameters.active, requestParameters.startDate, requestParameters.endDate, requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BannersApiPublicityBannersDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApi
     */
    public publicityBannersDestroy(requestParameters: BannersApiPublicityBannersDestroyRequest, options?: RawAxiosRequestConfig) {
        return BannersApiFp(this.configuration).publicityBannersDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApi
     */
    public publicityBannersList(options?: RawAxiosRequestConfig) {
        return BannersApiFp(this.configuration).publicityBannersList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BannersApiPublicityBannersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApi
     */
    public publicityBannersPartialUpdate(requestParameters: BannersApiPublicityBannersPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return BannersApiFp(this.configuration).publicityBannersPartialUpdate(requestParameters.id, requestParameters.active, requestParameters.startDate, requestParameters.endDate, requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BannersApiPublicityBannersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApi
     */
    public publicityBannersRetrieve(requestParameters: BannersApiPublicityBannersRetrieveRequest, options?: RawAxiosRequestConfig) {
        return BannersApiFp(this.configuration).publicityBannersRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BannersApiPublicityBannersUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApi
     */
    public publicityBannersUpdate(requestParameters: BannersApiPublicityBannersUpdateRequest, options?: RawAxiosRequestConfig) {
        return BannersApiFp(this.configuration).publicityBannersUpdate(requestParameters.id, requestParameters.image, requestParameters.id2, requestParameters.startDate, requestParameters.endDate, requestParameters.active, options).then((request) => request(this.axios, this.basePath));
    }
}

